module.exports = __webpack_public_path__ + "static/media/product-delete-icon.4dd78552.svg";